<template>
 <div class="dib">
   <Button :type="type">{{$t(textKey)}}</Button>
</div>
</template>

<script>
export default {
  name: 'ipsosButton',
  props: ['textKey', 'type', 'size'],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {
    _size () {
      return this.size || 'small'
    }
  },
  methods: {

  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuButton.vue